export const PRODUCTS_PER_PAGE = 12;
export const PRODUCTS_PER_PAGE_SEARCH_RESULT = 6;
